export default function IosAmericanfootball() {
  return (
    <div
      className="ion-icon-ios-americanfootball"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path d="M378.605,133.395C305.902,60.691,189.381,47.998,116.85,48c-38.926,0.001-65.191,3.658-65.191,3.658
			s-29.984,215.227,81.736,326.947C206.099,451.309,322.617,464,395.148,464c38.927,0,65.193-3.658,65.193-3.658
			S490.327,245.116,378.605,133.395z M68.124,194.728L194.707,68.146c6.123,0.861,12.164,1.825,18.112,2.899L71.025,212.838
			C69.955,206.901,68.987,200.862,68.124,194.728z M267.312,335.195l28.688-28.688l-22.627-22.628l-28.688,28.688l-11.313-11.312
			l28.688-28.688l-22.627-22.627l-28.688,28.688l-11.313-11.312l28.688-28.688l-22.628-22.628l-28.688,28.688l-11.313-11.312
			l28.689-28.689l-22.628-22.627l-28.688,28.688l-11.314-11.313l67.884-67.883l11.313,11.314l-28.688,28.688l22.628,22.627
			l28.688-28.688l11.313,11.313l-28.688,28.688l22.628,22.628l28.688-28.688l11.314,11.313l-28.688,28.688l22.627,22.627
			l28.688-28.688l11.313,11.312l-28.688,28.688l22.628,22.628l28.688-28.688l11.312,11.313l-28.688,28.688l22.627,22.627
			l28.688-28.688l11.314,11.312l-67.883,67.884l-11.313-11.313l28.688-28.688l-22.628-22.628l-28.688,28.688L267.312,335.195z
			 M317.259,443.891c-6.121-0.863-12.159-1.83-18.104-2.906L440.979,299.16c1.071,5.938,2.038,11.977,2.901,18.111L317.259,443.891z
			"/>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
